import React, { useCallback, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAuto, FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";

export default function CustomerPopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, dataX, formName, setUpdateFlag } = props;
  const [data, setData] = useState(null);
  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.custId === 0) {
      setData(null);
      goReady();
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/customer/get-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const fData1 = Object.fromEntries(dForm1);

    let dataToSave = {
      ItemId: selectedRow.row["custid"],
      SaveInfo: { ...fData1, brchid: userDetail.brchid },
      UserDetail: userDetail,
    };

    if (selectedRow.custId === 0) {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        createby: userDetail.userid,
      };
    } else {
      dataToSave.SaveInfo = {
        ...dataToSave.SaveInfo,
        updateby: userDetail.userid,
      };
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/customer/update",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const FILEDS = [
    { label: "รหัสลูกค้า", oName: "custcode", require: true, type: "text" },
    {
      label: "คำนำหน้า",
      oName: "prefixid",
      require: true,
      type: "select",
      rows: dataX && dataX.Prefix && dataX.Prefix,
    },
    { label: "ชื่อลูกค้า", oName: "cust_name", require: true, type: "text" },
    { label: "ชื่อแบบสั้น", oName: "cust_short", require: true, type: "text" },
    {
      label: "ประเภท",
      oName: "cust_type_id",
      require: true,
      type: "select",
      rows: dataX && dataX.CustType && dataX.CustType,
    },
    { label: "ที่อยู่", oName: "addr", require: true, type: "text" },
    { label: "   ", oName: "addr2", require: true, type: "text" },
    { label: "ชื่อผู้ติดต่อ", oName: "cust_contact_name", type: "text" },
    { label: "โทรศัพท์", oName: "cust_mobile", type: "text" },
    { label: "เลขประจำตัวผู้เสียภาษี", oName: "cust_tax_id", type: "text" },
  ];
  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal show={winState.show} size="xl" centered backdrop={false}>
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        {FILEDS ? (
          <FormAutoB
            {...{ formId: "form1", items: FILEDS, data: data, refTo: refForm1 }}
          />
        ) : null}
      </ModalBodyBlack>

      <ModalFooterBlack>
        <Button variant="primary" onClick={() => saveData()}>
          Save changes
        </Button>
        <Button variant="danger" onClick={() => setWinState({ show: false })}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
